import { PureComponent } from 'react';
import noimage from 'Lib/assets/noimage.png';

class NoImage extends PureComponent {
    render() {
        const image = noimage;

        return <img src={image} alt={image} {...this.props} />;
    }
}

export default NoImage;
